export const SDG_Table_TYPE_REQUEST = 'SDG_Table_TYPE_REQUEST';
export const SDG_Table_TYPE_SUCCESS = 'SDG_Table_TYPE_SUCCESS';
export const SDG_Table_TYPE_FAIL = 'SDG_Table_TYPE_FAIL';

